module.exports = __webpack_public_path__ + "static/media/meerkat_banner_small.45d40774.png";